<template>
<!-- <InverterWorkMap class="mt1x pl1x pr1x curP" :deviceData="li" @click="activeCard(li)"></InverterWorkMap> -->
<div class="deviceWorkMap deviceWorkMap-inverter" @click="$emit('click')">
	<div class="lineBox tableSys">
		<div class="w2x"></div>
		<div class="posR">
			<div class="line line-base"></div>
			<div class="line line-top"></div>
			<div class="line line-bottom"></div>
		</div>
		<div class="partText"></div>
	</div>
	<div class="part part-a" :title="getLanguageStr('plant413','直流离散率')+':'+floatFix(deviceData.dcDispersionRate,2,'%')"><Icon name="deviceData-discreteRate" :sizeBase="'xs'" /><div class="data">{{floatFix(deviceData.dcDispersionRate,2,"%")}}</div></div>
	<div class="part part-acdc"><Icon name="ACDC" :sizeBase="'xs'" /></div>
	<div class="part part-b"><Icon name="deviceData-P" :sizeBase="'xs'" />
		<div class="data cSub">
			<div :title="getLanguageStr('plant_detail357','发电功率')+':'+floatFix(deviceData.generationPower,2,'W')">{{floatFix(deviceData.generationPower,2)}}</div>
			<div :title="getLanguageStr('plant_list8','功率归一化')+':'+floatFix(deviceData.generationCapacity,2,'%')">{{floatFix(deviceData.generationCapacity,2,'%')}}</div>
		</div>
	</div>
	<div class="part part-c"><Icon name="deviceData-E" :sizeBase="'xs'" />
		<div class="data cSub">
			<div :title="getLanguageStr('plant_list26','当日发电量')+':'+floatFix(deviceData.generation,2,'kWh')">{{floatFix(deviceData.generation,2)}}</div>
			<div :title="getLanguageStr('device_management78','当日满发小时')+':'+floatFix(deviceData.fullPowerHoursDay,2,'h')">{{floatFix(deviceData.fullPowerHoursDay,2,'h')}}</div>
		</div>
	</div>
	<div class="part part-d"><Icon name="deviceData-capability" :sizeBase="'xs'" />
		<div class="data" :class="getTypeText(deviceData.inverterPerformance,'deviceCapability','object').fontClass||'cSub'">
			{{getTypeText(deviceData.inverterPerformance,'deviceCapability','object').name||'--'}}
		</div>
	</div>
</div>
</template>
<script>
import * as lib from '@/util/lib';
export default{
	name:"",
	components:{},
	props:{
		deviceData:{
			type:Object,
			default:()=>{return {};}
		},
		addClass:{//激活的索引项
			type:[String,Object],
			default:""
		},
	},
	data(){
		return{}
	},
	watch:{},
	methods:{
		getLanguageStr,
		getTypeText: lib.getTypeText,
		floatFix: lib.floatFix,
		convertData: lib.convertData,
		show:function(){
		}
	},
	computed:{
	},
	created(){},
	mounted(){},
	destroyed(){}
}
</script>
<style lang="scss" scoped>
$workMapTextWidth:5em;
.deviceWorkMap{
	.part-acdc{margin:{left:-3em};}
	.part-a{margin:{top:-1em;};border:1px solid $primary;top:50%;
		.data{width:5em;margin:{left:-2.5em;top:1em;};text-align:center;left:50%;}
	}
	.part-b{margin:{top:-5em;};top:50%;right:$workMapTextWidth + 2em;
		.data{left:3em;top:-.8em;}
	}
	.part-c{margin:{top:-1em;};top:50%;right:$workMapTextWidth + 2em;
		.data{left:3em;top:-.8em;}
	}
	.part-d{margin:{top:3em;};top:50%;right:$workMapTextWidth + 2em;
		.data{left:3em;top:0;}
	}
	.data{width:$workMapTextWidth;position:absolute;}
	.partText{width:$workMapTextWidth + 2em + 1em;}

	.lineBox{
		// .line-base{}
		.line-top{width:25%;height:4em;margin:{top:-4em;};border-top:1px dotted $primary;border-left:1px dotted $primary;right:0;}
		.line-bottom{width:25%;height:4em;border-bottom:1px dotted $primary;border-left:1px dotted $primary;right:0;}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/common/deviceWorkMap/Inverter.vue